import TradeRequestDisplayResponse from '../pages/TradeRequestDisplayResponse.vue';
import TradeRequestManageResponse from '../pages/TradeRequestManageResponse.vue';
import TradeRequestDirectManageResponse from '../pages/TradeRequestDirectManageResponse.vue';
import TradeRequestDirectListsOfResponsesPerItem from '../pages/TradeRequestDirectListsOfResponsesPerItem.vue';
import TradeRequestListsOfResponsesPerItem from '../pages/TradeRequestListsOfResponsesPerItem.vue';
import TradeFinalizePage from '../pages/TradeFinalizePage.vue';

const tradeRequestDisplayResponseRoutes = [
    {
        path: '/trade-request-display-response/:id',
        name: 'مشاهده پاسخ ها',
        component: TradeRequestDisplayResponse,
        meta: {
          roles: ['merchant','supplier','consumer'],
        },
    },
    {
      path: '/trade-request-finalize',
      name: 'فرم ابلاغ',
      component: TradeFinalizePage,
      meta: {
        roles: ['merchant','supplier','consumer'],
      },
  },
    {
      path: '/trade-request-manage-response/:id',
      name: 'کنترل پیشنهادات',
      component: TradeRequestManageResponse,
      meta: {
        roles: ['merchant','supplier','consumer'],
      },
  },
    {
      path: '/trade-request-direct-manage-response/:id',
      name: 'بررسی پیشنهاد',
      component: TradeRequestDirectManageResponse,
      meta: {
        roles: ['merchant','supplier','consumer'],
      },
  },
  {
    path: '/trade-request-list-per-item',
    name: 'کنترل پاسخ ها',
    component: TradeRequestListsOfResponsesPerItem,
    meta: {
      roles: ['merchant','supplier','consumer'],
    },
  },
  
    {
    path: '/trade-request-direct-list-per-item',
    name: 'کنترل پاسخ ',
    component: TradeRequestDirectListsOfResponsesPerItem,
    meta: {
      roles: ['merchant','supplier','consumer'],
    },
},
];
export default tradeRequestDisplayResponseRoutes;